<script>
  import ReboqueService from '../../../../domain/reboque/services/reboque'
  import {debounce} from 'lodash'

export default {
    components: { },
    name: 'ConsultaReboque',
    data () {
      return {
        isLoading: false,
        data: null,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 100
        },
        filtros: {
          busca: '',
          actives: null
        },
        filterKey: '',
        sortKey: '',
        sortOrders: {
          'numero': 1,
          'titulo': 1,
          'comitente': 1
        },
        prevent: {}
      }
    },
    filters: {
      capitalize: function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
      }
    },
    computed: {
      filteredData: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let order = this.sortOrders[sortKey] || 1
        let data = this.data
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      noData () {
        let data = 'data'
        if (this[data] === null) return false
        return this[data].length === 0
      }
    },
    beforeCreate () {
      const permitidaConsultaReboque = JSON.parse(localStorage.getItem('somenteConsultaReboque'))
      if (!permitidaConsultaReboque) return this.$router.back()
    },
    mounted () { },
    activated () { },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      load (limit, page, filtros) {
        this.data = null
        this.isLoading = true
        ReboqueService.list(limit, page, filtros)
          .then((response) => {
            console.log(response.data)
            this.data = response.data.result
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
            this.isLoading = false
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },

      montaFiltros () {
        let {busca, actives} = this.filtros
        let mount = ''
        mount += `&actives=${actives}`
        // Busca
        if (busca && busca.length > 0) {
          mount += '&busca=' + busca
        }
        return mount
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca.trim()
        if (!busca.length || this.prevent.busca === busca) return  // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.pagination.atualPage = 1
        this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 600)
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md m-b-lg">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3"> Consulta de Reboque </h1>
                  <small class="text-muted">
                    <!--<ordenar-arrematante></ordenar-leilao>-->
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">

                    <router-link :to="{name: 'logout'}" tag="button" class="btn btn-default btn-md ">
                      <i class="fa fa-sign-out"></i> Sair
                    </router-link>

                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="input-group main-container">
                <input
                  type="text"
                  class="input-sm form-control"
                  v-model="filtros.busca"
                  @keyup="pesquisar"
                  placeholder="DIGITE A PLACA DO REBOQUE"
                  autofocus
                >
              </div>

              <div class="text-center" v-if="isLoading">Carregando...</div>
              <div class="table-responsive main-container" v-else>
                <table class="table table-hover table-striped b-t b-light" v-show="filteredData && filteredData.length">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Identificação</th>
                    <th>Placa</th>
                    <th>Ativo</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td>
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <tr v-for="reboque in data">
                    <td>
                      <span class="text-cap custom-link">{{ reboque.id }}</span>
                    </td>
                    <td>
                      <span class="text-cap custom-link">{{ reboque.identificacao }}</span>
                    </td>
                    <td>
                      <span class="text-cap custom-link">{{ reboque.placa }}</span>
                    </td>
                    <td>
                      <span class="text-cap custom-link" v-if="reboque.ativo">Ativo</span>
                      <span class="text-cap custom-link text-danger" v-else>Inativo</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <span class="text-center" v-if="filtros.busca && filteredData && !filteredData.length">Nenhum registro encontrado</span>
              </div>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.main-container {
  width: 80%;
  position: relative;
  margin: 0 auto;

  input {
    height: 60px;
    width: 100%;
    font-size: large;
    text-align: center;
    margin-bottom: 25px;
    text-transform: uppercase;

    &:focus {
      outline: none !important;
      border: 1px solid darkgrey;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ConsultaReboque.vue?1cef2ce6